import { useState, useEffect, Fragment } from "react";

// ui
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Checkbox,
} from "@mui/material";

// InterFace
import {
  TableColumn,
  DataColumn,
  SubDataColumn,
  EditDataDifine,
} from "../../config/dataInterface";
import { getOneYearListDetail } from "../../lib/other";
import {
  DataDetailRowContractNumberMonths,
  DataDetailRowCustomerInfo,
  DataDetailRowContractInfo,
  DataDetailRowOptionSelect,
  DataDetailRowElse,
} from "./DataDetailComponent";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";

import { CONST } from "../../config/const";

interface DataDetailTableProps {
  onModal?: boolean;
  swCloseModal?: () => void;
  detailTitle: string;
  editAuth: string[];
  dataColumn: DataColumn[];
  subDataColumn: SubDataColumn[];
  dataDetail: {
    [key: string]:
      | number
      | string
      | { [key: string]: string | number }[]
      | { [key: string]: string | string[] };
  } | null;
  setEditData: (data: EditDataDifine | null) => void;
  setEditProduct?: (data: { [key: string]: any } | null) => void;
  dataDetailOption: {
    [key: string]: string | number;
  }[];
  dataDetailOptionSelect: {
    [key: string]: string;
  }[];
  dataDetailHistory: {
    selected_date: string;
    contract_version: number;
  }[];
  selectHistory?: number;
  getOldDataDetail?: (
    id: string,
    service_plan_id: string,
    contract_version: number
  ) => void;
  getGroupList: (id: string) => void;
  setEditProductOptionPlans?: (
    value: {
      service_plan_id: number;
      service_plan_name: string;
    }[]
  ) => void;
  setEditProductOptionContents?: (
    value: {
      service_content_id: number;
      service_content_name: string;
    }[]
  ) => void;
  setEditTossUpFormOptionProducts?: (
    value: {
      high_rank_company_name: string;
      product_id: number;
      product_name: string;
    }[]
  ) => void;
  setEditOutsideServices?: (
    value: {
      outside_entry_form_service_id: number;
      outside_entry_form_service_name: string;
    }[]
  ) => void;
  setSelectServiseInfo: (value: {
    service_plan_data: { service_name: string }[];
    service_content_data: { service_name: string }[];
    service_campaign_pulldown_data: { service_name: string }[];
    service_campaign_checkbox_data: { service_name: string }[];
  }) => void;
  setSelectTossUpInfo: (value: {
    tossUpCategoryNameList: {
      category_id: number;
      category_name: string;
    }[];
    tossUpProductNameList: {
      category_id: number;
      category_name: string;
      product_name: string;
    }[];
  }) => void;
  checkFlagRow?: {
    label: string;
    checked: boolean;
    disabled: boolean;
    onToggle: () => void;
  };
  contractInfoRows?: { key: string; value: string }[];
}

export function DataDetailTable(props: DataDetailTableProps) {
  const {
    detailTitle,
    editAuth,
    dataColumn,
    subDataColumn,
    dataDetail,
    setEditData,
    dataDetailOption,
    dataDetailOptionSelect,
    dataDetailHistory,
    getGroupList,
    setSelectServiseInfo,
    setSelectTossUpInfo,
    checkFlagRow,
    contractInfoRows,
  } = props;

  const resolvedHistory = dataDetailHistory ?? [];

  const loginUser = useAtomValue(AppAtoms.loginUser);
  const pathname = useAtomValue(AppAtoms.pathname);

  const [lastContractVersion, setLastContractVersion] = useState<number>(0);
  useEffect(() => {
    if (resolvedHistory.length === 0) return;
    const last_contract_version = resolvedHistory.reduce(
      (max, item) =>
        item.contract_version > max ? item.contract_version : max,
      resolvedHistory[0].contract_version
    );
    setLastContractVersion(last_contract_version);
  }, [resolvedHistory]);

  if (!dataDetail) return null;

  const headerCellSx = {
    backgroundColor: "var(--color-ai)",
    color: "var(--color-white)",
    fontSize: "11px",
    fontWeight: 700,
    padding: "8px 12px",
  };

  // 件31: 詳細ゼブラ化 — 描画行カウンタ（データ行emitごと加算・見出し行/header除外）
  let dataRowIdx = 0;

  const tableEl = (
    <Table stickyHeader size="small" aria-label="detail table">
      <TableHead>
        <TableRow key="detailTableRow">
          <TableCell
            key="tableColumnKomoku"
            align="left"
            sx={{ width: "30%", minWidth: "150px", ...headerCellSx }}
          >
            <Box className="table-header">質問名</Box>
          </TableCell>
          <TableCell
            key="tableColumnShosai"
            align="left"
            sx={{ width: "60%", minWidth: "200px", ...headerCellSx }}
          >
            <Box className="table-header">詳細</Box>
          </TableCell>
          {loginUser?.authority &&
          editAuth.findIndex(
            (authority) => authority === loginUser.authority
          ) > -1 &&
          ((pathname === "/toss_up" &&
            dataDetail["disable_change"] === 1) ||
            pathname !== "/toss_up") &&
          ((resolvedHistory.length > 0 &&
            dataDetail.contract_version === lastContractVersion) ||
            resolvedHistory.length === 0) ? (
            <TableCell
              key="tableColumnEdit"
              align="center"
              sx={{ width: "10%", minWidth: "30px", ...headerCellSx }}
            >
              <Box className="table-header">編集</Box>
            </TableCell>
          ) : null}
        </TableRow>
      </TableHead>
      <TableBody>
        {dataColumn.map((col, i) => {
          if (col.detail) {
            if (col.key === "contract_number_months") {
              return (
                <Fragment key={"cnm-section-" + i}>
                  <TableRow className="dt-sub">
                    <TableCell align="left" sx={{ color: "var(--color-sumi)", fontSize: "12px", backgroundColor: "var(--color-washi)", paddingLeft: "var(--sp-6)" }}>
                      <Box className="table-body">契約番号月別（12ヶ月）</Box>
                    </TableCell>
                    <TableCell align="left" sx={{ color: "var(--color-sumi)", fontSize: "12px", backgroundColor: "var(--color-washi)" }}></TableCell>
                    {loginUser?.authority &&
                    editAuth.findIndex((authority) => authority === loginUser.authority) > -1 &&
                    ((pathname === "/toss_up" && dataDetail["disable_change"] === 1) || pathname !== "/toss_up") &&
                    ((resolvedHistory.length > 0 && dataDetail.contract_version === lastContractVersion) || resolvedHistory.length === 0) ? (
                      <TableCell align="center"></TableCell>
                    ) : null}
                  </TableRow>
                  {getOneYearListDetail().map((yearMonth, year_i) => {
                    const bg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
                    return (
                      <DataDetailRowContractNumberMonths
                        key={"cnm" + year_i}
                        editAuth={editAuth}
                        dataColumn={col}
                        dataDetail={dataDetail}
                        dataDetailHistory={resolvedHistory}
                        lastContractVersion={lastContractVersion}
                        year_i={year_i}
                        yearMonth={yearMonth}
                        detailType="datail"
                        rowBg={bg}
                      />
                    );
                  })}
                </Fragment>
              );
            } else if (col.key === "customer_info") {
              return dataDetailOption.map(
                (
                  {
                    option_id,
                    option_name,
                    option_type,
                    tel_flg,
                    name_flg,
                    company_name_flg,
                    half_width_number_flg,
                    multi_text_flg,
                    entry_method,
                  },
                  option_i,
                ) => {
                  const bg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
                  const customer_info = dataDetail.customer_info as {
                    [key: string]: string | string[];
                  };
                  const optionValue = customer_info[option_name as string];
                  return (
                    <DataDetailRowCustomerInfo
                      key={"ci" + option_i}
                      editAuth={editAuth}
                      dataColumn={col}
                      dataDetail={dataDetail}
                      dataDetailHistory={resolvedHistory}
                      lastContractVersion={lastContractVersion}
                      setEditData={setEditData}
                      option_i={option_i}
                      option_id={option_id}
                      option_name={option_name}
                      option_type={option_type}
                      tel_flg={tel_flg}
                      name_flg={name_flg}
                      company_name_flg={company_name_flg}
                      half_width_number_flg={half_width_number_flg}
                      multi_text_flg={multi_text_flg}
                      entry_method={entry_method}
                      optionValue={optionValue}
                      customer_info={customer_info}
                      detailType="datail"
                      rowBg={bg}
                    />
                  );
                },
              );
            } else if (col.key === "option_select") {
              return dataDetailOptionSelect.map((optionSelect, key_i) => {
                const bg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
                return (
                  <DataDetailRowOptionSelect
                    key={"os" + key_i}
                    optionSelect={optionSelect}
                    key_i={key_i}
                    rowBg={bg}
                  />
                );
              });
            } else if (
              ((col.key === "hope_call_time" &&
                dataDetail["hope_call_time_kind"] === "時間指定") ||
                col.key !== "hope_call_time") &&
              ((col.key === "closing_memo" &&
                (dataDetail["toss_up_status"] === "クロージング-成功" ||
                  dataDetail["toss_up_status"] ===
                    "クロージング-成功（未エントリー）")) ||
                col.key !== "closing_memo") &&
              ((col.key === "closing_failed_memo" &&
                dataDetail["toss_up_status"] === "クロージング-失敗") ||
                col.key !== "closing_failed_memo") &&
              ((col.key === "return_call_memo" &&
                (dataDetail["toss_up_status"] === "不出" ||
                  dataDetail["toss_up_status"] === "時節" ||
                  dataDetail["toss_up_status"] === "見込み")) ||
                col.key !== "return_call_memo") &&
              ((col.key === "sns_send_flg" &&
                (dataDetail["service_type"] === "キャンペーン（プルダウン）" ||
                  dataDetail["service_type"] ===
                    "キャンペーン（チェックボックス）")) ||
                col.key !== "sns_send_flg")
            ) {
              if (
                loginUser &&
                col.tableDetailAuth.includes(loginUser.authority)
              ) {
                const bg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
                return (
                  <DataDetailRowElse
                    key={"dc" + i}
                    editAuth={editAuth}
                    dataDetail={dataDetail}
                    dataDetailHistory={resolvedHistory}
                    lastContractVersion={lastContractVersion}
                    setEditData={setEditData}
                    i={i}
                    dataColumnName={col.name}
                    dataColumnKey={col.key}
                    dataColumnEdit={col.edit}
                    dataColumnEditType={
                      col.editType === "outside_site_logo"
                        ? "outside_site_logo"
                        : col.editType === "outside_site_favicon"
                        ? "outside_site_favicon"
                        : col.editType === "list"
                        ? "list"
                        : col.editType === "multitext"
                        ? "multitext"
                        : col.editType === "screen_column"
                        ? "screen_column"
                        : col.editType === "entry_info"
                        ? "entry_info"
                        : col.editType === "toss_up_info"
                        ? "toss_up_info"
                        : "text"
                    }
                    dataColumnEditId={col.editId}
                    detailTitle={detailTitle}
                    dataColumnTableValue={col.tableValue}
                    getGroupList={getGroupList}
                    detailType="datail"
                    setSelectServiseInfo={setSelectServiseInfo}
                    setSelectTossUpInfo={setSelectTossUpInfo}
                    rowBg={bg}
                  />
                );
              }
            }
          }
          return null;
        })}
        {subDataColumn.map((col, i) => {
          if (col.detail) {
            if (col.key === "option_select") {
              return dataDetailOptionSelect.map((optionSelect, key_i) => {
                const bg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
                return (
                  <DataDetailRowOptionSelect
                    key={"sos" + key_i}
                    optionSelect={optionSelect}
                    key_i={key_i}
                    rowBg={bg}
                  />
                );
              });
            } else {
              const bg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
              return (
                <DataDetailRowElse
                  key={"sdc" + i}
                  editAuth={editAuth}
                  dataDetail={dataDetail}
                  dataDetailHistory={resolvedHistory}
                  lastContractVersion={lastContractVersion}
                  setEditData={setEditData}
                  i={i}
                  dataColumnName={col.name}
                  dataColumnKey={col.key}
                  dataColumnEdit={col.edit}
                  dataColumnEditType={
                    col.editType === "site_pdf_path"
                      ? "site_pdf_path"
                      : col.editType === "list"
                      ? "list"
                      : col.editType === "multitext"
                      ? "multitext"
                      : "text"
                  }
                  dataColumnEditId={col.editId}
                  detailTitle={detailTitle}
                  dataColumnTableValue={col.tableValue}
                  getGroupList={getGroupList}
                  detailType="datail"
                  setSelectServiseInfo={setSelectServiseInfo}
                  setSelectTossUpInfo={setSelectTossUpInfo}
                  rowBg={bg}
                />
              );
            }
          }
          return null;
        })}
        {contractInfoRows && contractInfoRows.length > 0 && (
          <>
            <TableRow>
              <TableCell
                colSpan={4}
                sx={{
                  backgroundColor: "var(--color-ai)",
                  color: "var(--color-white)",
                  fontWeight: 400,
                  fontSize: 12,
                  py: 0.5,
                  borderBottom: "1px solid var(--color-border, rgb(230,230,230))",
                }}
              >
                契約情報一覧（{contractInfoRows.length}件）
              </TableCell>
            </TableRow>
            {contractInfoRows.map((row, key_i) => {
              const bg = dataRowIdx++ % 2 === 1 ? "var(--color-ai-pale)" : undefined;
              return (
                <DataDetailRowContractInfo
                  key={"cinfo" + key_i}
                  editAuth={editAuth}
                  dataDetail={dataDetail}
                  dataDetailHistory={resolvedHistory}
                  lastContractVersion={lastContractVersion}
                  key_i={key_i}
                  contractInfoKey={row.key}
                  contractInfoValue={row.value}
                  detailType="datail"
                  rowBg={bg}
                />
              );
            })}
          </>
        )}
        {checkFlagRow && (
          <TableRow key="check-flag-row">
            <TableCell align="left" sx={{ width: "30%", minWidth: "150px" }}>
              <Box className="table-body">{checkFlagRow.label}</Box>
            </TableCell>
            <TableCell align="left" sx={{ width: "60%", minWidth: "200px" }}>
              <Checkbox
                disabled={checkFlagRow.disabled}
                checked={checkFlagRow.checked}
                onClick={checkFlagRow.onToggle}
                sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }}
              />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );

  return (
    <TableContainer
      component={Paper}
      data-testid="detail-view"
      sx={{
        flex: "1 1 auto",
        minHeight: 0,
        margin: "1px 1px",
        width: "calc(100% - 4px)",
        border: "1px solid var(--color-border, rgb(230, 230, 230))",
        borderRadius: "var(--radius-md, 10px)",
        overflow: "auto",
      }}
    >
      {tableEl}
    </TableContainer>
  );
}
